module.exports = __webpack_public_path__ + "img/words-slider-prev.eb5827d1.svg";